import 'modernizr';
import '../bootstrap';

import Accessibility from '../modules/accessibility';
import Tracking from '../modules/tracking';
import FormValidation from '../modules/formValidation';
import navigation from '../modules/navigation';
import jumpToElement from '../modules/jumpToElement';
import toggle from '../modules/toggle';
import filter from '../modules/filter/filter';
import whatsapp from '../modules/whatsapp';
import generalSlider from '../modules/generalSlider';
import datesList from '../modules/datesList';
import dateSelectModal from '../modules/dateSelectModal';
import datepicker from '../modules/datepicker';
import advTable from '../modules/advTable';
import enrollDate from '../modules/enrollDate';
import videoElement from '../modules/videoElement';
import embedWrap from '../modules/embedWrap';
import searchBlock from '../modules/searchBlock';
import enrollSignupType from '../modules/enrollSignupType';
import mediaGrid from '../modules/mediaGrid';
import companyHeader from '../modules/companyHeader';
import autofox from '../modules/autofox';
import vacancyRequestModal from '../modules/vacancyRequestModal';
// insert-import

const general = () => {
  window.App.tracking = new Tracking(window.App);
  window.App.accessibility = new Accessibility(window.App);
  window.App.formValidation = new FormValidation();
  navigation.initialize();
  jumpToElement.initialize();
  toggle.initialize();
  filter.initialize();
  whatsapp.initialize();
  generalSlider.initialize();
  datesList.initialize();
  dateSelectModal.initialize();
  datepicker.initialize();
  advTable.initialize();
  enrollDate.initialize();
  videoElement.initialize();
  embedWrap();
  searchBlock.initialize();
  enrollSignupType.initialize();
  mediaGrid.initialize();
  companyHeader.initialize();
  autofox.initialize();
  vacancyRequestModal.initialize();
  // insert-definition
};

export default general;
